import { DataEffectif } from "./effectif.model";


export class Option {

  //Nom a afficher dans la légende du fieldset
  Title: string;

  //Icone a afficher dans la légende du fielset
  Icon: string;

  //Sert a différencier les instances des composants effectifs
  IdInstances: string = "";

  //Permet de choisir le type de rendu des effectif soit personne morale soit physique
  RenderType: RenderType;
  DataType: DataType;

  //Permet d'afficher des cases a cocher (? ou des radio btn ?) pour sélectionner un ou plusieurs effectifs, que sera retourné sur l'output
  SelectionMode: SelectionMode;

  SelectionModePopOver: SelectionMode;

  // permet d'afficher ou pas un btn pour ouvrir le bo en mode modif
  Update: boolean;

  // permet d'afficher ou pas le btn d'ouverture du popover de gestion des effectifs
  Add: boolean;

  // permet d'afficher ou pas le bouton et la liste des données liées aux cycles
  Cycles: boolean;

  // permet d'afficher ou pas le bouton pour ouvrir le bo en mode create
  Create: boolean;

  CanCommentLien: boolean;

  AllData: DataEffectif;
  SelectedData: DataEffectif;
  FilteredData: DataEffectif;

  GridName: string;

  Mode: ModeEffectif;

  //finir de nettoyer 
  /**
   * construit une instance de Option en fonction d'un ModeEffectif donné
   * @param idSelected ident donnée sélectionnée
   * @param idAll ident donnée
   * @param pMode de type ModeEffectif
   * @param pSelectionMode de type SelectionMode ou null, utilise la valeur par défaut du pMode si null
   * @param pSelectionModePopOver de type SelectionMode ou null, utilise la valeur par défaut du pMode si null
   */
  constructor(idSelected: string, idAll: string, pMode: ModeEffectif, pIdInstances:string = "", pSelectionMode: SelectionMode | null = null, pSelectionModePopOver: SelectionMode | null = null, pGridName: string | null = null/*, update: boolean = false, add: boolean = false, cycles: boolean = false*/) {
    this.GridName = '';
    this.IdInstances = pIdInstances;
    this.Mode = pMode;

    switch (pMode) {
      case ModeEffectif.ALLCONTACTRH: 
        this.DataType = DataType.CONTACTRH;
        this.Title = "Responsable d'inscription";
        this.Icon = "fas fa-user-tie";
        this.RenderType = RenderType.PP;
        this.SelectionMode = SelectionMode.MULTIPLE;
        this.SelectionModePopOver = SelectionMode.NONE;
        this.Update = false;
        this.Add = false;
        this.Cycles = false;
        this.CanCommentLien = false;
        this.AllData = { IdOrigin: '', Origin: '', Relation: '' };
        this.SelectedData = { IdOrigin: idSelected, Origin: 'Fils_LIE', Relation: 'REL_BO_CSOC_BO_STAGE' };
        this.FilteredData = { IdOrigin: idSelected, Origin: 'Fils_LIE', Relation: 'REL_BO_CSOC_BO_STAGE'  }
        break;
     
      case ModeEffectif.PREINSCRITS:
        this.DataType = DataType.PREINSCRITS;
        this.Title = "Préinscrits";
        this.Icon = "fas fa-users";
        this.RenderType = RenderType.PP;
        this.SelectionMode = SelectionMode.NONE;
        this.SelectionModePopOver = SelectionMode.NONE;
        this.Update = false;
        this.Add = false;
        this.Cycles = false;
        this.CanCommentLien = false;
        this.AllData = { IdOrigin: '', Origin: '', Relation: '' };
        this.SelectedData = { IdOrigin: idSelected, Origin: 'Fils_LIE', Relation: 'REL_BO_CONTACT_BO_STAGE' };
        this.FilteredData = { IdOrigin: idSelected, Origin: '', Relation: 'REL_BO_CSOC_BO_CONTACT_PREINSCRITS' };
        this.GridName = 'ListePreInscritsEffectifs';

        break;

      case ModeEffectif.ALLSTAGIAIRE:
        this.DataType = DataType.DEFAULT;
        this.Title = "Apprenants";
        this.Icon = "fas fa-user-graduate";
        this.RenderType = RenderType.PP;
        this.SelectionMode = SelectionMode.NONE;
        this.SelectionModePopOver = SelectionMode.MULTIPLE;
        this.Update = false;
        this.Add = false;
        this.Cycles = false;
        this.CanCommentLien = false;
        this.AllData = { IdOrigin: idAll, Origin: 'Fils_LIE', Relation: 'REL_BO_CONTACT_BO_STAGE' };
        this.SelectedData = { IdOrigin: idSelected, Origin: '', Relation: '' };
        this.FilteredData = { IdOrigin: '', Origin: '', Relation: '' };
        this.GridName = 'ListeAllStagiairesEffectifs';
        break;

      case ModeEffectif.ALLFORMATEUR:
        this.DataType = DataType.FORMATEUR;
        this.Title = "Formateurs";
        this.Icon = "fas fa-chalkboard-teacher";
        this.RenderType = RenderType.PPPHOTO;
        this.SelectionMode = SelectionMode.NONE;
        this.SelectionModePopOver = SelectionMode.MULTIPLE;
        this.Update = false;
        this.Add = true;
        this.Cycles = false;
        this.CanCommentLien = false;
        this.AllData = { IdOrigin: '1348', Origin: 'Pere_LIE', Relation: 'REL_BO_CENT_BO_FORMATEUR' };
        this.SelectedData = { IdOrigin: idSelected, Origin: 'Fils_LIE', Relation: 'REL_BO_FORMATEUR_BO_STAGE' };
        this.FilteredData = { IdOrigin: '', Origin: '', Relation: '' };
        this.GridName = 'ListeFormateursEffectifs';
        break;

      case ModeEffectif.FORMATEURSINGLE:
        this.DataType = DataType.FORMATEUR;
        this.Title = "Formateurs";
        this.Icon = "fas fa-chalkboard-teacher";
        this.RenderType = RenderType.PPPHOTO;
        this.SelectionMode = SelectionMode.SINGLE;
        this.SelectionModePopOver = SelectionMode.MULTIPLE;
        this.Update = false;
        this.Add = false;
        this.CanCommentLien = false;
        this.Cycles = false;
        this.AllData = { IdOrigin: '1348', Origin: 'Pere_LIE', Relation: 'REL_BO_CENT_BO_FORMATEUR' };
        this.SelectedData = { IdOrigin: idSelected, Origin: 'Fils_LIE', Relation: 'REL_BO_FORMATEUR_BO_STAGE' };
        this.FilteredData = { IdOrigin: '', Origin: '', Relation: '' }
        break;

      case ModeEffectif.ALLCLIENT:
        this.DataType = DataType.DEFAULT;
        this.Title = "Clients";
        this.Icon = "fas fa-user-tie";
        this.RenderType = RenderType.PMSTAGE;
        this.SelectionMode = SelectionMode.NONE;
        this.SelectionModePopOver = SelectionMode.MULTIPLE;
        this.Update = false;
        this.Add = true;
        this.Cycles = false;
        this.Create = true;
        this.CanCommentLien = true;
        this.AllData = { IdOrigin: idAll, Origin: 'Pere_LIE', Relation: 'REL_BO_CENT_BO_CSOC' };
        this.SelectedData = { IdOrigin: idSelected, Origin: 'Fils_LIE', Relation: 'REL_BO_CSOC_BO_STAGE' };
        this.FilteredData = { IdOrigin: '', Origin: '', Relation: '' };
        this.GridName = 'ListeClientsEffectifs';

        break;

      case ModeEffectif.STAGIAIRECLIENT:
        this.DataType = DataType.DEFAULT;
        this.Title = "Apprenants";
        this.Icon = "fas fa-user-graduate";
        this.RenderType = RenderType.PPPHOTO;
        this.SelectionMode = SelectionMode.NONE;
        this.SelectionModePopOver = SelectionMode.MULTIPLE;
        this.Update = true;
        this.Add = true;
        this.Cycles = false;
        this.Create = true;
        this.CanCommentLien = true;
        this.AllData = { IdOrigin: '', Origin: 'Pere_LIE', Relation: 'REL_BO_CSOC_BO_CONTACT' };
        this.SelectedData = { IdOrigin: idSelected, Origin: 'Fils_LIE', Relation: 'REL_BO_CONTACT_BO_STAGE' };
        this.FilteredData = { IdOrigin: idSelected, Origin: 'Fils_LIE', Relation: 'REL_BO_CSOC_BO_STAGE' };
        this.GridName = 'ListeApprenantsEffectifs';
        break;

      case ModeEffectif.STAGIAIREMAIL:
        this.DataType = DataType.DEFAULT;
        this.Title = "Apprenants";
        this.Icon = "fas fa-user-graduate";
        this.RenderType = RenderType.PPPHOTO;
        this.SelectionMode = SelectionMode.MULTIPLE;
        this.Update = true;
        this.Add = false;
        this.Cycles = false;
        this.CanCommentLien = false;
        this.AllData = { IdOrigin: '', Origin: 'Pere_LIE', Relation: 'REL_BO_CSOC_BO_CONTACT' };
        this.SelectedData = { IdOrigin: idSelected, Origin: 'Fils_LIE', Relation: 'REL_BO_CONTACT_BO_STAGE' };
        this.FilteredData = { IdOrigin: idSelected, Origin: 'Fils_LIE', Relation: 'REL_BO_CSOC_BO_STAGE' }
        break;

      case ModeEffectif.CLIENTMAIL:
        this.DataType = DataType.DEFAULT;
        this.Title = "Clients";
        this.Icon = "fas fa-user-tie";
        this.RenderType = RenderType.PM;
        this.SelectionMode = SelectionMode.MULTIPLE;
        this.Update = false;
        this.Add = false;
        this.Cycles = false;
        this.CanCommentLien = false;
        this.AllData = { IdOrigin: idAll, Origin: 'Pere_LIE', Relation: 'REL_BO_CENT_BO_CSOC' };
        this.SelectedData = { IdOrigin: idSelected, Origin: 'Fils_LIE', Relation: 'REL_BO_CSOC_BO_STAGE' };
        this.FilteredData = { IdOrigin: '', Origin: '', Relation: '' }
        break;

      case ModeEffectif.FORMATEURMAIL:
        this.DataType = DataType.FORMATEUR;
        this.Title = "Formateurs";
        this.Icon = "fas fa-chalkboard-teacher";
        this.RenderType = RenderType.PPPHOTO;
        this.SelectionMode = SelectionMode.MULTIPLE;
        this.Update = false;
        this.Add = false;
        this.Cycles = false;
        this.CanCommentLien = false;
        this.AllData = { IdOrigin: '1348', Origin: 'Pere_LIE', Relation: 'REL_BO_CENT_BO_FORMATEUR' };
        this.SelectedData = { IdOrigin: idSelected, Origin: 'Fils_LIE', Relation: 'REL_BO_FORMATEUR_BO_STAGE' };
        this.FilteredData = { IdOrigin: '', Origin: '', Relation: '' }
        break;

      default:
        break;
    }
    if (pGridName != null) {
      this.GridName = pGridName;
    }
    if (pSelectionMode != null) {
      this.SelectionMode = pSelectionMode;
    }
    if (pSelectionModePopOver != null) {
      this.SelectionModePopOver = pSelectionModePopOver;
    }
  }
}

//Permet de choisir le type de rendu des effectif soit personne morale soit physique
export enum RenderType {
  PM,
  PP,
  PPPHOTO,
  PMSTAGE,
}
export enum DataType {
  DEFAULT,
  PREINSCRITS,
  CONTACTRH,
  FORMATEUR,
}
//Permet d'afficher des cases a cocher (? ou des radio btn ?) pour sélectionner un ou plusieurs effectifs, que sera retourné sur l'output
export enum SelectionMode {
  NONE,
  SINGLE,
  MULTIPLE,
}

//Definit le cas qu'on souhaite afficher ( exemple : STAGIAIRE/CLIENT )
export enum ModeEffectif {
  ALLSTAGIAIRE,
  ALLFORMATEUR,
  ALLCLIENT,
  ALLCONTACTRH,
  STAGIAIRECLIENT,
  STAGIAIREMAIL,
  FORMATEURMAIL,
  CLIENTMAIL,
  PREINSCRITS,
  FORMATEURSINGLE
}

//définit des règles d'updates spécifiques
export enum ModeEffectifUpdate {
  INSERT_CLIENT_OF_STAGIAIRE,
  PUSH_CLIENT_IN_FILTER,
  REMOVE_CLIENT_FROM_FILTER
}


export class PopOverConfig {
  // permet l'ouverture du bo de création
  Create: boolean;

  SelectionMode: SelectionMode;

  RelationPere: string;

  RelationMultiPere: string;

  RenderType: RenderType;
}
